<div class="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">

  <!-- Header de la página -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h1 class="text-xl font-medium text-gray-900 dark:text-white m-0">Cockpit comercial</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1 m-0">{{ todayLabel }}</p>
    </div>
    <!-- TODO RF-15: el buscador global vivirá en el header del layout, no aquí -->
  </div>

  <!-- Grilla 2x2 de widgets -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">

    <!-- WIDGET 1: Ingresos del mes (RF-04, RF-05) -->
    <app-dashboard-widget-card
    title="Ingresos del mes"
    subtitle="Negocios ganados este mes"
    iconBgClass="bg-green-50 dark:bg-green-900/20"
    [state]="revenue.state"
    drillDownLabel="Ver negocios ganados →"
    (retry)="loadRevenue()"
    (drillDown)="onRevenueDrillDown()">

    <svg icon class="w-4 h-4 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>

    <!-- Monto principal del mes actual -->
    <p class="text-3xl font-medium text-gray-900 dark:text-white m-0 leading-tight">
        S/ {{ revenue.data?.currentMonthTotal | number:'1.2-2' }}
    </p>

    <!-- Badge de variación + dato del mes anterior -->
    <div class="flex items-center gap-2 mt-2 flex-wrap">

        <!-- Badge: verde si subió, rojo si bajó -->
        <span
        class="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-md"
        [ngClass]="isRevenuePositive
            ? 'bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400'
            : 'bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400'">

        <!-- Flecha hacia arriba o hacia abajo -->
        <svg *ngIf="isRevenuePositive" class="w-2.5 h-2.5" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
            <polyline points="18 15 12 9 6 15"/>
        </svg>
        <svg *ngIf="!isRevenuePositive" class="w-2.5 h-2.5" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
            <polyline points="6 9 12 15 18 9"/>
        </svg>

        {{ revenueVariationAbs | number:'1.1-1' }}%
        </span>

        <!-- Dato del mes anterior (en gris, contexto) -->
        <span class="text-xs text-gray-500 dark:text-gray-400">
        vs. mes anterior (S/ {{ revenue.data?.previousMonthTotal | number:'1.2-2' }})
        </span>

    </div>

    </app-dashboard-widget-card>

    <!-- WIDGET 2: Contactos nuevos del mes (RF-08, RF-09) -->
    <app-dashboard-widget-card
    title="Contactos nuevos del mes"
    subtitle="Distribución total por fuente"
    iconBgClass="bg-blue-50 dark:bg-blue-900/20"
    [state]="leads.state"
    drillDownLabel="Ver todos los contactos →"
    emptyMessage="Aún no se han registrado contactos este mes"
    (retry)="loadLeads()"
    (drillDown)="onLeadsDrillDown()">

    <svg icon class="w-4 h-4 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M22 11h-6"/>
        <path d="M19 8v6"/>
    </svg>

    <!-- Total grande -->
    <div class="flex items-baseline gap-2 mb-3">
        <p class="text-3xl font-medium text-gray-900 dark:text-white m-0 leading-tight">
        {{ leads.data?.totalLeads }}
        </p>
        <p class="text-xs text-gray-500 dark:text-gray-400 m-0">
        Total CRM: {{ totalContactsAcrossSources(leads.data?.bySource) }} en {{ leads.data?.bySource?.length }} fuentes
        </p>
    </div>

    <!-- Desglose por fuente: barras compactas -->
    <div class="flex flex-col gap-1.5">
        <div *ngFor="let source of leads.data?.bySource"
            class="flex items-center gap-2 text-xs">

        <!-- Nombre de la fuente -->
        <span class="text-gray-600 dark:text-gray-400 min-w-[90px] truncate">
            {{ source.originName }}
        </span>

        <!-- Barra azul -->
        <div class="flex-1 h-1.5 bg-blue-50 dark:bg-gray-700 rounded-full overflow-hidden">
            <div
            class="h-full bg-blue-500 dark:bg-blue-400 rounded-full transition-all duration-300"
            [style.width.%]="getSourceWidthPercent(source.count)">
            </div>
        </div>

        <!-- Cantidad + porcentaje -->
        <span class="text-gray-700 dark:text-gray-300 font-medium min-w-[24px] text-right">
            {{ source.count }}
        </span>
        <span class="text-gray-400 dark:text-gray-500 min-w-[36px] text-right">
            {{ getSourcePercentage(source.count) | number:'1.0-0' }}%
        </span>

        </div>
    </div>

    </app-dashboard-widget-card>

    <!-- WIDGET 3: Embudo de ventas (RF-06, RF-07) -->
    <app-dashboard-widget-card
    title="Embudo de ventas"
    [subtitle]="'Pipeline activo · Total S/ ' + (funnel.data?.totalPipelineAmount | number:'1.2-2')"
    iconBgClass="bg-purple-50 dark:bg-purple-900/20"
    [state]="funnel.state"
    drillDownLabel="Ver pipeline completo →"
    emptyMessage="No hay negocios activos en el pipeline"
    (retry)="loadFunnel()"
    (drillDown)="onFunnelDrillDown()">

    <svg icon class="w-4 h-4 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
    </svg>

    <div class="flex flex-col gap-2.5">

        <div *ngFor="let stage of funnel.data?.stages; let i = index"
            class="cursor-pointer group"
            (click)="onStageClick(stage.stageId)">

        <!-- Header de cada etapa: nombre + monto + cantidad -->
        <div class="flex justify-between items-center mb-1 text-xs">
            <span class="font-medium text-gray-700 dark:text-gray-300 group-hover:text-purple-700 dark:group-hover:text-purple-400">
            {{ stage.stageName }}
            </span>
            <span class="text-gray-500 dark:text-gray-400">
            {{ stage.dealsCount }} {{ stage.dealsCount === 1 ? 'negocio' : 'negocios' }}
            · S/ {{ stage.totalAmount | number:'1.0-0' }}
            </span>
        </div>

        <!-- Barra horizontal proporcional al monto -->
        <div class="h-4 bg-purple-50 dark:bg-gray-700 rounded-md overflow-hidden">
            <div
            class="h-full rounded-md transition-all duration-300 group-hover:opacity-90"
            [class]="getStageColor(i, (funnel.data?.stages?.length ?? 1))"
            [style.width.%]="getStageWidthPercent(stage.totalAmount)">
            </div>
        </div>

        </div>

    </div>

    </app-dashboard-widget-card>

    <!-- WIDGET 4: Mi agenda (RF-10, RF-11) -->
      <app-dashboard-widget-card
        title="Mi agenda"
        subtitle="Llamadas de hoy y tareas atrasadas"
        iconBgClass="bg-amber-50 dark:bg-amber-900/20"
        [state]="agenda.state"
        drillDownLabel="Ver todas mis tareas →"
        emptyMessage="No tienes llamadas ni tareas pendientes 🎉"
        (retry)="loadAgenda()"
        (drillDown)="onAgendaDrillDown()">

    <svg icon class="w-4 h-4 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>

    <!-- Sección: Llamadas de hoy -->
    <div *ngIf="(agenda.data?.callsToday?.length ?? 0) > 0" class="mb-3">
        <div class="flex items-center gap-2 mb-2">
        <span class="text-xs font-medium text-gray-700 dark:text-gray-300">Llamadas de hoy</span>
        <span class="text-xs text-gray-400 dark:text-gray-500">·</span>
        <span class="text-xs text-gray-500 dark:text-gray-400">{{ agenda.data?.callsToday?.length }}</span>
        </div>

        <div class="flex flex-col gap-1">
        <div *ngFor="let task of agenda.data?.callsToday"
            class="flex items-center gap-2 px-2 py-1.5 bg-gray-50 dark:bg-gray-700/50 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer transition-colors"
            (click)="onAgendaItemClick(task.id)">
            <span class="text-xs font-medium text-blue-600 dark:text-blue-400 min-w-[40px]">
            {{ formatTaskTime(task.dueDatetime) }}
            </span>
            <span class="text-xs text-gray-700 dark:text-gray-200 flex-1 truncate">
            {{ task.contactName }}<span *ngIf="task.title"> — {{ task.title }}</span>
            </span>
        </div>
        </div>
    </div>

    <!-- Sección: Tareas atrasadas -->
    <div *ngIf="(agenda.data?.overdueTasks?.length ?? 0) > 0">
        <div class="flex items-center gap-2 mb-2">
        <span class="text-xs font-medium text-red-600 dark:text-red-400">Tareas atrasadas</span>
        <span class="text-xs text-gray-400 dark:text-gray-500">·</span>
        <span class="text-xs text-red-600 dark:text-red-400">{{ agenda.data?.overdueTasks?.length }}</span>
        </div>

        <div class="flex flex-col gap-1">
        <div *ngFor="let task of agenda.data?.overdueTasks"
            class="flex items-center gap-2 px-2 py-1.5 bg-red-50 dark:bg-red-900/10 rounded-md hover:bg-red-100 dark:hover:bg-red-900/20 cursor-pointer transition-colors"
            (click)="onAgendaItemClick(task.id)">
            <span class="text-xs font-medium text-red-600 dark:text-red-400 min-w-[40px]">
            {{ getOverdueLabel(task.dueDatetime) }}
            </span>
            <span class="text-xs text-gray-700 dark:text-gray-200 flex-1 truncate">
            {{ task.title }}<span *ngIf="task.contactName"> · {{ task.contactName }}</span>
            </span>
        </div>
        </div>
    </div>

    </app-dashboard-widget-card>

    <!-- WIDGET 5: Tickets — mini-dashboard -->
    <app-dashboard-widget-card
      title="Tickets"
      [subtitle]="'Resumen del servicio al cliente · ' + (tickets.data?.total ?? 0) + ' totales'"
      iconBgClass="bg-cyan-50 dark:bg-cyan-900/20"
      [state]="tickets.state"
      drillDownLabel="Ver todos los tickets →"
      emptyMessage="No hay tickets registrados"
      (retry)="loadTickets()"
      (drillDown)="onTicketsDrillDown()">

      <svg icon class="w-4 h-4 text-cyan-600 dark:text-cyan-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M21 10V8a2 2 0 0 0-2-2h-3.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 10.93 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2"/>
        <polyline points="9 14 11 16 15 12"/>
      </svg>

      <!-- SECCIÓN 1: Estado actual (barra apilada + leyenda) -->
      <div class="mb-4">
        <div class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">Estado actual</div>

        <!-- Barra apilada -->
        <div class="flex h-7 w-full rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-700 mb-2">
          <div *ngIf="(tickets.data?.openPercent ?? 0) > 0"
               class="bg-blue-500 dark:bg-blue-400 flex items-center justify-center text-xs font-medium text-white"
               [style.width.%]="getTicketSegmentWidth(tickets.data?.openPercent ?? 0)"
               [title]="'Abiertos: ' + tickets.data?.open">
            <span *ngIf="(tickets.data?.openPercent ?? 0) >= 12">{{ tickets.data?.open }}</span>
          </div>
          <div *ngIf="(tickets.data?.inProgressPercent ?? 0) > 0"
               class="bg-amber-500 dark:bg-amber-400 flex items-center justify-center text-xs font-medium text-white"
               [style.width.%]="getTicketSegmentWidth(tickets.data?.inProgressPercent ?? 0)"
               [title]="'En proceso: ' + tickets.data?.inProgress">
            <span *ngIf="(tickets.data?.inProgressPercent ?? 0) >= 12">{{ tickets.data?.inProgress }}</span>
          </div>
          <div *ngIf="(tickets.data?.closedPercent ?? 0) > 0"
               class="bg-green-500 dark:bg-green-400 flex items-center justify-center text-xs font-medium text-white"
               [style.width.%]="getTicketSegmentWidth(tickets.data?.closedPercent ?? 0)"
               [title]="'Cerrados: ' + tickets.data?.closed">
            <span *ngIf="(tickets.data?.closedPercent ?? 0) >= 12">{{ tickets.data?.closed }}</span>
          </div>
        </div>

        <!-- Leyenda compacta -->
        <div class="flex items-center gap-4 text-xs">
          <span class="inline-flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-blue-500"></span>
            <span class="text-gray-600 dark:text-gray-400">Abiertos:</span>
            <span class="font-medium text-gray-900 dark:text-white tabular-nums">{{ tickets.data?.open }}</span>
          </span>
          <span class="inline-flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-amber-500"></span>
            <span class="text-gray-600 dark:text-gray-400">En proceso:</span>
            <span class="font-medium text-gray-900 dark:text-white tabular-nums">{{ tickets.data?.inProgress }}</span>
          </span>
          <span class="inline-flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-green-500"></span>
            <span class="text-gray-600 dark:text-gray-400">Cerrados:</span>
            <span class="font-medium text-gray-900 dark:text-white tabular-nums">{{ tickets.data?.closed }}</span>
          </span>
        </div>
      </div>

      <!-- SECCIÓN 2: Actividad de hoy -->
      <div class="grid grid-cols-2 gap-3 mb-4 pt-3 border-t border-gray-100 dark:border-gray-700">
        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Creados hoy</span>
          <div class="flex items-baseline gap-1.5">
            <span class="text-lg font-medium text-gray-900 dark:text-white tabular-nums">{{ tickets.data?.createdToday ?? 0 }}</span>
            <span class="text-xs text-gray-400 dark:text-gray-500">nuevas solicitudes</span>
          </div>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Resueltos hoy</span>
          <div class="flex items-baseline gap-1.5">
            <span class="text-lg font-medium text-green-600 dark:text-green-400 tabular-nums">{{ tickets.data?.resolvedToday ?? 0 }}</span>
            <span class="text-xs text-gray-400 dark:text-gray-500">cerrados</span>
          </div>
        </div>
      </div>

      <!-- SECCIÓN 3: Calidad y SLA -->
      <div class="pt-3 border-t border-gray-100 dark:border-gray-700">
        <div class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">Calidad y SLA</div>

        <div class="grid grid-cols-3 gap-2 mb-2">
          <div class="flex flex-col gap-0.5">
            <span class="text-xs text-gray-500 dark:text-gray-400">CSAT</span>
            <span class="text-sm font-medium text-gray-900 dark:text-white tabular-nums">
              {{ tickets.data?.csatAvg != null
                  ? (tickets.data?.csatAvg | number:'1.1-1') + '/5'
                  : '—' }}
            </span>
          </div>
          <div class="flex flex-col gap-0.5">
            <span class="text-xs text-gray-500 dark:text-gray-400">1ª respuesta</span>
            <span class="text-sm font-medium text-gray-900 dark:text-white tabular-nums">
              {{ formatMinutes(tickets.data?.avgFirstResponseMin ?? null) }}
            </span>
          </div>
          <div class="flex flex-col gap-0.5">
            <span class="text-xs text-gray-500 dark:text-gray-400">Resolución</span>
            <span class="text-sm font-medium text-gray-900 dark:text-white tabular-nums">
              {{ formatMinutes(tickets.data?.avgResolutionMin ?? null) }}
            </span>
          </div>
        </div>

        <!-- Alertas SLA -->
        <div class="flex items-center gap-3 text-xs">
          <span class="inline-flex items-center gap-1.5"
                [class.text-amber-600]="(tickets.data?.slaAtRisk ?? 0) > 0"
                [class.dark:text-amber-400]="(tickets.data?.slaAtRisk ?? 0) > 0"
                [class.text-gray-500]="(tickets.data?.slaAtRisk ?? 0) === 0"
                [class.dark:text-gray-400]="(tickets.data?.slaAtRisk ?? 0) === 0">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <span>SLA en riesgo: <span class="font-medium tabular-nums">{{ tickets.data?.slaAtRisk ?? 0 }}</span></span>
          </span>
          <span class="inline-flex items-center gap-1.5"
                [class.text-red-600]="(tickets.data?.slaBreached ?? 0) > 0"
                [class.dark:text-red-400]="(tickets.data?.slaBreached ?? 0) > 0"
                [class.text-gray-500]="(tickets.data?.slaBreached ?? 0) === 0"
                [class.dark:text-gray-400]="(tickets.data?.slaBreached ?? 0) === 0">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
            <span>SLA vencido: <span class="font-medium tabular-nums">{{ tickets.data?.slaBreached ?? 0 }}</span></span>
          </span>
        </div>
      </div>

    </app-dashboard-widget-card>

    <!-- WIDGET 6: Embudo de correos (RF-XX) — Funnel -->
    <app-dashboard-widget-card
      title="Embudo de correos"
      [subtitle]="(emailFunnel.data?.campaignsThisMonth ?? 0) + ' campañas enviadas este mes'"
      iconBgClass="bg-indigo-50 dark:bg-indigo-900/20"
      [state]="emailFunnel.state"
      drillDownLabel="Ver todas las campañas →"
      emptyMessage="No hay campañas de correo registradas"
      (retry)="loadEmailFunnel()"
      (drillDown)="onEmailFunnelDrillDown()">

      <svg icon class="w-4 h-4 text-indigo-600 dark:text-indigo-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>

      <!-- SECCIÓN 1: Estado de campañas -->
      <div class="mb-4">
        <div class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">Estado de campañas</div>
        <div class="flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs">
          <span class="inline-flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-green-500"></span>
            <span class="text-gray-600 dark:text-gray-400">Enviadas:</span>
            <span class="font-medium text-gray-900 dark:text-white tabular-nums">{{ emailFunnel.data?.campaignsByStatus?.sent ?? 0 }}</span>
          </span>
          <span class="inline-flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-gray-400"></span>
            <span class="text-gray-600 dark:text-gray-400">Borradores:</span>
            <span class="font-medium text-gray-900 dark:text-white tabular-nums">{{ emailFunnel.data?.campaignsByStatus?.draft ?? 0 }}</span>
          </span>
          <span class="inline-flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-blue-500"></span>
            <span class="text-gray-600 dark:text-gray-400">Programadas:</span>
            <span class="font-medium text-gray-900 dark:text-white tabular-nums">{{ emailFunnel.data?.campaignsByStatus?.scheduled ?? 0 }}</span>
          </span>
          <span class="inline-flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-red-500"></span>
            <span class="text-gray-600 dark:text-gray-400">Canceladas:</span>
            <span class="font-medium text-gray-900 dark:text-white tabular-nums">{{ emailFunnel.data?.campaignsByStatus?.cancelled ?? 0 }}</span>
          </span>
        </div>
      </div>

      <!-- SECCIÓN 2: Funnel de envío (4 etapas) -->
      <div class="mb-4 pt-3 border-t border-gray-100 dark:border-gray-700">
        <div class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">Flujo de envío</div>

        <div *ngIf="(emailFunnel.data?.campaignsThisMonth ?? 0) > 0" class="flex flex-col gap-2">
          <div *ngFor="let stage of emailFunnel.data?.stages; let i = index" class="group">
            <!-- Header: nombre + cantidad + % vs anterior -->
            <div class="flex justify-between items-baseline mb-1 text-xs">
              <span class="font-medium text-gray-700 dark:text-gray-300">{{ stage.label }}</span>
              <div class="flex items-center gap-2">
                <span class="text-gray-900 dark:text-white font-medium tabular-nums">{{ stage.count | number }}</span>
                <span *ngIf="i > 0" class="text-gray-500 dark:text-gray-400">
                  {{ stage.percentFromPrevious | number:'1.1-1' }}% vs anterior
                </span>
              </div>
            </div>
            <!-- Barra proporcional al % total -->
            <div class="h-5 bg-indigo-50 dark:bg-gray-700 rounded-md overflow-hidden">
              <div class="h-full rounded-md transition-all duration-300 group-hover:opacity-90 flex items-center justify-end pr-2"
                   [class]="i === 0 ? 'bg-indigo-500 dark:bg-indigo-400'
                          : i === 1 ? 'bg-indigo-400 dark:bg-indigo-500'
                          : i === 2 ? 'bg-indigo-300 dark:bg-indigo-600'
                          : 'bg-indigo-200 dark:bg-indigo-700'"
                   [style.width.%]="getEmailStageWidth(stage.percentFromTotal)">
                <span *ngIf="stage.percentFromTotal >= 20" class="text-xs font-medium text-white">
                  {{ stage.percentFromTotal | number:'1.0-0' }}%
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Sin campañas enviadas este mes -->
        <p *ngIf="(emailFunnel.data?.campaignsThisMonth ?? 0) === 0"
           class="text-xs text-gray-400 italic text-center py-3">
          No se han enviado campañas este mes
        </p>
      </div>

      <!-- SECCIÓN 3: Métricas clave -->
      <div *ngIf="(emailFunnel.data?.campaignsThisMonth ?? 0) > 0"
           class="grid grid-cols-4 gap-2 pt-3 border-t border-gray-100 dark:border-gray-700">

        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Open Rate</span>
          <span class="text-base font-medium text-green-600 dark:text-green-400 tabular-nums">
            {{ emailFunnel.data?.metrics?.openRate != null
                ? (emailFunnel.data?.metrics?.openRate | number:'1.1-1') + '%'
                : '—' }}
          </span>
        </div>

        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">CTOR</span>
          <span class="text-base font-medium text-purple-600 dark:text-purple-400 tabular-nums">
            {{ emailFunnel.data?.metrics?.ctor != null
                ? (emailFunnel.data?.metrics?.ctor | number:'1.1-1') + '%'
                : '—' }}
          </span>
        </div>

        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Bounces</span>
          <span class="text-base font-medium tabular-nums"
                [class]="(emailFunnel.data?.metrics?.bounces ?? 0) > 0
                        ? 'text-red-600 dark:text-red-400'
                        : 'text-gray-900 dark:text-white'">
            {{ emailFunnel.data?.metrics?.bounces ?? 0 }}
          </span>
        </div>

        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Fallidos</span>
          <span class="text-base font-medium tabular-nums"
                [class]="(emailFunnel.data?.metrics?.failed ?? 0) > 0
                        ? 'text-red-600 dark:text-red-400'
                        : 'text-gray-900 dark:text-white'">
            {{ emailFunnel.data?.metrics?.failed ?? 0 }}
          </span>
        </div>

      </div>

    </app-dashboard-widget-card>

    <!-- WIDGET 7: Negocios por estado (RF-XX) — Dona SVG -->
    <app-dashboard-widget-card
      title="Negocios por estado"
      [subtitle]="'Total: ' + (businesses.data?.total ?? 0) + ' negocios · S/ ' + (businesses.data?.totalAmount | number:'1.0-0')"
      iconBgClass="bg-emerald-50 dark:bg-emerald-900/20"
      [state]="businesses.state"
      drillDownLabel="Ver todos los negocios →"
      emptyMessage="No hay negocios registrados"
      (retry)="loadBusinesses()"
      (drillDown)="onBusinessesDrillDown()">

      <svg icon class="w-4 h-4 text-emerald-600 dark:text-emerald-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M12 2v20M2 12h20"/>
        <circle cx="12" cy="12" r="10"/>
      </svg>

      <!-- Layout: dona a la izquierda, leyenda a la derecha -->
      <div class="flex items-center gap-6">

        <!-- Dona SVG -->
        <div class="relative flex-shrink-0">
          <svg viewBox="0 0 42 42" class="w-32 h-32 -rotate-90">
            <!-- Círculo de fondo (gris) -->
            <circle
              cx="21" cy="21" r="15.915"
              fill="none"
              class="stroke-gray-100 dark:stroke-gray-700"
              stroke-width="4">
            </circle>

            <!-- Segmentos de colores -->
            <circle
              *ngFor="let seg of getDonutSegments()"
              cx="21" cy="21" r="15.915"
              fill="none"
              [attr.stroke]="seg.color"
              stroke-width="4"
              [attr.stroke-dasharray]="seg.dashArray"
              [attr.stroke-dashoffset]="seg.dashOffset"
              class="transition-all duration-500">
            </circle>
          </svg>

          <!-- Texto central: total -->
          <div class="absolute inset-0 flex flex-col items-center justify-center">
            <span class="text-2xl font-medium text-gray-900 dark:text-white leading-none">
              {{ businesses.data?.total }}
            </span>
            <span class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">negocios</span>
          </div>
        </div>

         <!-- Leyenda con TODAS las etapas (incluso las vacías) -->
        <div class="flex-1 flex flex-col gap-2 max-h-48 overflow-y-auto pr-1">
          <div *ngFor="let slice of businesses.data?.slices"
               class="flex items-center gap-2 text-xs"
               [class.opacity-50]="slice.count === 0">

            <!-- Punto de color (gris si está vacío) -->
            <span class="w-2.5 h-2.5 rounded-full flex-shrink-0"
                [style.background-color]="slice.count > 0 ? slice.color : '#d1d5db'"></span>

            <!-- Etiqueta con nombre REAL del CRM (ocupa todo el espacio sobrante) -->
            <span class="text-gray-600 dark:text-gray-400 flex-1 truncate"
                  [title]="slice.stageName">
              {{ slice.stageName }}
            </span>

            <!-- Bloque de números agrupado a la derecha, espaciado uniforme -->
            <div class="flex items-center gap-3 flex-shrink-0">
              <!-- Cantidad -->
              <span class="text-gray-900 dark:text-white font-medium w-6 text-right tabular-nums">
                {{ slice.count }}
              </span>

              <!-- Porcentaje -->
              <span class="text-gray-400 dark:text-gray-500 w-12 text-right tabular-nums">
                {{ slice.percent | number:'1.0-1' }}%
              </span>

              <!-- Monto en S/ -->
              <span class="text-gray-500 dark:text-gray-400 w-20 text-right tabular-nums">
                S/ {{ slice.amount | number:'1.0-0' }}
              </span>
            </div>

          </div>
        </div>

      </div>

    </app-dashboard-widget-card>

    <!-- WIDGET 8: Reuniones (RF-XX) — Tabs: por tipo / contactos / empresas -->
    <app-dashboard-widget-card
      title="Reuniones"
      [subtitle]="'Total: ' + (meetings.data?.totals?.grandTotal ?? 0) + ' reuniones'"
      iconBgClass="bg-pink-50 dark:bg-pink-900/20"
      [state]="meetings.state"
      drillDownLabel="Ver todas las reuniones →"
      emptyMessage="No hay reuniones registradas"
      (retry)="loadMeetings()"
      (drillDown)="onMeetingsDrillDown()">

      <svg icon class="w-4 h-4 text-pink-600 dark:text-pink-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        <line x1="9" y1="10" x2="15" y2="10"/>
        <line x1="12" y1="7" x2="12" y2="13"/>
      </svg>

      <!-- Tabs -->
      <div class="flex items-center gap-1 mb-3 border-b border-gray-100 dark:border-gray-700">
        <button
          (click)="setMeetingsTab('types')"
          [class]="meetingsActiveTab === 'types'
            ? 'px-3 py-1.5 text-xs font-medium text-pink-600 dark:text-pink-400 border-b-2 border-pink-500 -mb-px'
            : 'px-3 py-1.5 text-xs font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'">
          Por tipo
        </button>
        <button
          (click)="setMeetingsTab('contacts')"
          [class]="meetingsActiveTab === 'contacts'
            ? 'px-3 py-1.5 text-xs font-medium text-pink-600 dark:text-pink-400 border-b-2 border-pink-500 -mb-px'
            : 'px-3 py-1.5 text-xs font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'">
          Contactos
          <span class="ml-1 text-gray-400">({{ meetings.data?.byContact?.length ?? 0 }})</span>
        </button>
        <button
          (click)="setMeetingsTab('companies')"
          [class]="meetingsActiveTab === 'companies'
            ? 'px-3 py-1.5 text-xs font-medium text-pink-600 dark:text-pink-400 border-b-2 border-pink-500 -mb-px'
            : 'px-3 py-1.5 text-xs font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'">
          Empresas
          <span class="ml-1 text-gray-400">({{ meetings.data?.byCompany?.length ?? 0 }})</span>
        </button>
      </div>

      <!-- TAB 1: Por tipo (pivot dinámica) -->
      <div *ngIf="meetingsActiveTab === 'types'" class="overflow-x-auto">
        <table class="w-full text-xs">
          <thead>
            <tr class="border-b border-gray-100 dark:border-gray-700">
              <th class="text-left py-2 pr-2 font-medium text-gray-500 dark:text-gray-400">Tipo</th>
              <th class="text-right py-2 px-2 font-medium text-gray-500 dark:text-gray-400">
                <span class="inline-flex items-center gap-1">
                  <span class="w-1.5 h-1.5 rounded-full bg-blue-500"></span>Prog.
                </span>
              </th>
              <th class="text-right py-2 px-2 font-medium text-gray-500 dark:text-gray-400">
                <span class="inline-flex items-center gap-1">
                  <span class="w-1.5 h-1.5 rounded-full bg-green-500"></span>Realiz.
                </span>
              </th>
              <th class="text-right py-2 px-2 font-medium text-gray-500 dark:text-gray-400">
                <span class="inline-flex items-center gap-1">
                  <span class="w-1.5 h-1.5 rounded-full bg-red-500"></span>Cancel.
                </span>
              </th>
              <th class="text-right py-2 pl-2 font-medium text-gray-700 dark:text-gray-300">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of meetings.data?.rows"
                class="border-b border-gray-50 dark:border-gray-700/50 hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
              <td class="py-2 pr-2 text-gray-700 dark:text-gray-200 font-medium truncate max-w-[180px]" [title]="row.typeName">
                {{ row.typeName }}
              </td>
              <td class="py-2 px-2 text-right text-gray-600 dark:text-gray-300 tabular-nums">{{ row.scheduled }}</td>
              <td class="py-2 px-2 text-right text-gray-600 dark:text-gray-300 tabular-nums">{{ row.completed }}</td>
              <td class="py-2 px-2 text-right text-gray-600 dark:text-gray-300 tabular-nums">{{ row.cancelled }}</td>
              <td class="py-2 pl-2 text-right font-medium text-gray-900 dark:text-white tabular-nums">{{ row.total }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="border-t border-gray-200 dark:border-gray-600">
              <td class="py-2 pr-2 font-medium text-gray-700 dark:text-gray-300">Total</td>
              <td class="py-2 px-2 text-right font-medium text-gray-700 dark:text-gray-300 tabular-nums">{{ meetings.data?.totals?.scheduled }}</td>
              <td class="py-2 px-2 text-right font-medium text-gray-700 dark:text-gray-300 tabular-nums">{{ meetings.data?.totals?.completed }}</td>
              <td class="py-2 px-2 text-right font-medium text-gray-700 dark:text-gray-300 tabular-nums">{{ meetings.data?.totals?.cancelled }}</td>
              <td class="py-2 pl-2 text-right font-medium text-gray-900 dark:text-white tabular-nums">{{ meetings.data?.totals?.grandTotal }}</td>
            </tr>
          </tfoot>
        </table>

        <p *ngIf="(meetings.data?.rows?.length ?? 0) === 0" class="text-xs text-gray-400 italic text-center py-4">
          No hay reuniones con tipo definido
        </p>
      </div>

      <!-- TAB 2: Contactos -->
      <div *ngIf="meetingsActiveTab === 'contacts'" class="flex flex-col gap-1.5 max-h-56 overflow-y-auto">
        <button *ngFor="let c of meetings.data?.byContact"
                type="button"
                (click)="onMeetingContactClick(c.id)"
                class="flex items-center justify-between gap-2 px-2 py-1.5 bg-gray-50 dark:bg-gray-700/40 rounded-md hover:bg-pink-50 dark:hover:bg-pink-900/20 transition-colors group text-left w-full"
                [title]="'Editar ' + c.name">
          <span class="flex items-center gap-1.5 min-w-0">
            <span class="text-xs text-gray-700 dark:text-gray-200 truncate group-hover:text-pink-700 dark:group-hover:text-pink-400">
              {{ c.name }}
            </span>
            <svg class="w-3 h-3 text-gray-400 group-hover:text-pink-500 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0"
                 fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
          </span>
          <span class="text-xs font-medium text-pink-600 dark:text-pink-400 tabular-nums flex-shrink-0">
            {{ c.count }} {{ c.count === 1 ? 'reunión' : 'reuniones' }}
          </span>
        </button>
        <p *ngIf="(meetings.data?.byContact?.length ?? 0) === 0"
           class="text-xs text-gray-400 italic text-center py-4">
          Las reuniones no tienen contactos asociados
        </p>
      </div>

      <!-- TAB 3: Empresas -->
     <div *ngIf="meetingsActiveTab === 'companies'" class="flex flex-col gap-1.5 max-h-56 overflow-y-auto">
        <button *ngFor="let c of meetings.data?.byCompany"
                type="button"
                (click)="onMeetingCompanyClick(c.id)"
                class="flex items-center justify-between gap-2 px-2 py-1.5 bg-gray-50 dark:bg-gray-700/40 rounded-md hover:bg-pink-50 dark:hover:bg-pink-900/20 transition-colors group text-left w-full"
                [title]="'Editar ' + c.name">
          <span class="flex items-center gap-1.5 min-w-0">
            <span class="text-xs text-gray-700 dark:text-gray-200 truncate group-hover:text-pink-700 dark:group-hover:text-pink-400">
              {{ c.name }}
            </span>
            <svg class="w-3 h-3 text-gray-400 group-hover:text-pink-500 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0"
                 fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
          </span>
          <span class="text-xs font-medium text-pink-600 dark:text-pink-400 tabular-nums flex-shrink-0">
            {{ c.count }} {{ c.count === 1 ? 'reunión' : 'reuniones' }}
          </span>
        </button>
        <p *ngIf="(meetings.data?.byCompany?.length ?? 0) === 0"
           class="text-xs text-gray-400 italic text-center py-4">
          Las reuniones no tienen empresas asociadas
        </p>
      </div>

    </app-dashboard-widget-card>

    <!-- WIDGET 9: Cotizaciones — KPIs comerciales (requiere Manager+) -->
    <app-dashboard-widget-card
      *ngIf="!quotesForbidden"
      title="Cotizaciones"
      [subtitle]="'Resumen comercial · ' + (quotes.data?.totalQuotes ?? 0) + ' totales'"
      iconBgClass="bg-teal-50 dark:bg-teal-900/20"
      [state]="quotes.state"
      drillDownLabel="Ver todas las cotizaciones →"
      emptyMessage="No hay cotizaciones registradas"
      (retry)="loadQuotes()"
      (drillDown)="onQuotesDrillDown()">

      <svg icon class="w-4 h-4 text-teal-600 dark:text-teal-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="9" y1="13" x2="15" y2="13"/>
        <line x1="9" y1="17" x2="13" y2="17"/>
      </svg>

      <!-- SECCIÓN 1: Total + tasa de aceptación -->
      <div class="flex items-baseline gap-2 mb-1">
        <p class="text-3xl font-medium text-gray-900 dark:text-white m-0 leading-tight tabular-nums">
          {{ quotes.data?.totalQuotes ?? 0 }}
        </p>
        <span class="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-md bg-teal-50 text-teal-700 dark:bg-teal-900/20 dark:text-teal-400">
          {{ quotes.data?.acceptanceRatePct | number:'1.1-1' }}% aceptación
        </span>
      </div>
      <p class="text-xs text-gray-500 dark:text-gray-400 m-0 mb-4">
        <span class="text-green-600 dark:text-green-400 font-medium">{{ quotes.data?.acceptedCount ?? 0 }}</span> aceptadas ·
        <span class="text-red-600 dark:text-red-400 font-medium">{{ quotes.data?.rejectedCount ?? 0 }}</span> rechazadas
      </p>

      <!-- SECCIÓN 2: Montos -->
      <div class="grid grid-cols-2 gap-3 mb-4 pt-3 border-t border-gray-100 dark:border-gray-700">
        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Monto cotizado</span>
          <span class="text-lg font-medium text-gray-900 dark:text-white tabular-nums">
            S/ {{ quotes.data?.totalQuotedAmount | number:'1.0-0' }}
          </span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Monto ganado</span>
          <span class="text-lg font-medium text-green-600 dark:text-green-400 tabular-nums">
            S/ {{ quotes.data?.totalWonAmount | number:'1.0-0' }}
          </span>
        </div>
      </div>

      <!-- SECCIÓN 3: Tiempos y vencimientos -->
      <div class="grid grid-cols-3 gap-2 pt-3 border-t border-gray-100 dark:border-gray-700">
        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Días a cierre</span>
          <span class="text-sm font-medium text-gray-900 dark:text-white tabular-nums">
            {{ quotes.data?.avgDaysToClose | number:'1.0-1' }} días
          </span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Por vencer (7d)</span>
          <span class="text-sm font-medium tabular-nums"
                [class]="(quotes.data?.expiringIn7Days ?? 0) > 0
                        ? 'text-amber-600 dark:text-amber-400'
                        : 'text-gray-900 dark:text-white'">
            {{ quotes.data?.expiringIn7Days ?? 0 }}
          </span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-gray-500 dark:text-gray-400">Versiones prom.</span>
          <span class="text-sm font-medium text-gray-900 dark:text-white tabular-nums">
            {{ quotes.data?.avgVersionCount | number:'1.1-1' }}
          </span>
        </div>
      </div>

    </app-dashboard-widget-card>

  </div>
</div>